export default __webpack_public_path__ + "static/media/char_body_prem_017.58a098ac.png";